<template>
    <div class="page-container">
    <el-breadcrumb separator="/">
     <el-breadcrumb-item>
        <span class="page-title">社区投票</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <el-button type="primary" @click="setAvailableVotesNumber()">未开始项目的用户可投票数据初始化</el-button>
      </div>
      <el-tabs :value="ballotStatus" @tab-click="handleTabChange">
        <el-tab-pane label="所有" name="all"></el-tab-pane>
        <el-tab-pane v-for="(type, key) in statusTypes" :key="key" :label="type.text" :name="key"></el-tab-pane>
      </el-tabs>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import { STATUS_TYPES } from './constants.js';

export default {
  name: 'votingStrategy',
  data() {
    return {
      statusTypes: STATUS_TYPES,
      ballotStatus: 'all',
      snapshotTime:''
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('votingStrategy', ['pagination'])
  },
  methods: {
    ...mapActions('votingStrategy', ['getList','setAvailableVotes']),
    handleTabChange(tab) {
      this.ballotStatus = tab.name;
      this.getProjectList({page: 1})
    },
    getProjectList(data = {}) {
      this.getList({
        ballotStatus: this.ballotStatus === 'all'? undefined: this.ballotStatus,
        ...this.pagination,
        ...data
      });
    },
     setAvailableVotesNumber(){
        this.setAvailableVotes().then(response =>{
           this.$message.success(response.data)
        })
     }
  },
  created() {
    this.getProjectList();
  }
};
</script>
